export default {
  title: 'Reservations CSV',
  buttons: {
    generate: 'Generate & download',
  },
  fields: {
    date_range: 'Date range (optional)',
  },
  errors: {
    invalid_date_range: 'Please select a valid date range',
  },
};
